import { LocationControlResult } from '@grnhse/location-control';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import { useMemo } from 'react';

export const useSelectedLocation = (
  location: LocationControlResult | null
): Item<LocationControlResult> | null => {
  return useMemo(() => {
    if (!location) {
      return null;
    }

    return {
      label: location.label || location.displayName,
      value: location,
    };
  }, [location]);
};
